module.exports = __webpack_public_path__ + "img/dropdown.9624e3bc.svg";